import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";

const Add = () => {
  const navigate = useNavigate();
  const coverGalleryRef = useRef(null);
  const coverCameraRef = useRef(null);

  const userStr = localStorage.getItem("erpUser");
  const userData = userStr ? JSON.parse(userStr) : null;

  const [formData, setFormData] = useState({
    title: "",
    desc: "",
    price: "",
    qty: "",
    cover: "", // base64
    web: "",
    category: "",
    storeid: userData?.userid || "",
    active: 1,
  });

  const [categories, setCategories] = useState([]);
  const [coverPreview, setCoverPreview] = useState("https://placehold.co/300x300?text=Cover+Utama");

  // Multiple additional images
  const [additionalFiles, setAdditionalFiles] = useState([]);     // array of File objects
  const [additionalPreviews, setAdditionalPreviews] = useState([]); // array of base64 previews
  const [additionalDescs, setAdditionalDescs] = useState([]);      // array of descriptions

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Fetch categories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get("https://api.kamulyaan.id/category");
        setCategories(res.data || []);
      } catch (err) {
        console.error("Gagal memuat kategori:", err);
      }
    };
    fetchCategories();
  }, []);

  // Ensure storeid is set from logged-in user
  useEffect(() => {
    if (userData?.userid && formData.storeid !== userData.userid) {
      setFormData((prev) => ({ ...prev, storeid: userData.userid }));
    }
  }, [userData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Process cover image (gallery or camera)
  const processCoverImage = (file) => {
    if (!file) return;

    const previewUrl = URL.createObjectURL(file);
    setCoverPreview(previewUrl);

    const reader = new FileReader();
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;

      img.onload = () => {
        const canvas = document.createElement("canvas");
        const MAX_WIDTH = 600;
        const scale = MAX_WIDTH / img.width;
        canvas.width = MAX_WIDTH;
        canvas.height = img.height * scale;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        const compressedBase64 = canvas.toDataURL("image/jpeg", 0.7);
        setFormData((prev) => ({ ...prev, cover: compressedBase64 }));
      };
    };
    reader.readAsDataURL(file);
  };

  const handleCoverGallery = (e) => {
    const file = e.target.files?.[0];
    processCoverImage(file);
  };

  const handleCoverCamera = (e) => {
    const file = e.target.files?.[0];
    processCoverImage(file);
  };

  // FIXED: Handle multiple additional images (append, not replace)
  const handleAdditionalFilesChange = (e) => {
    const newSelectedFiles = Array.from(e.target.files || []);

    if (newSelectedFiles.length === 0) return;

    // Append to existing (don't replace)
    const updatedFiles = [...additionalFiles, ...newSelectedFiles].slice(0, 10);
    setAdditionalFiles(updatedFiles);

    // Update descriptions (add empty strings for new files)
    const updatedDescs = [
      ...additionalDescs,
      ...Array(newSelectedFiles.length).fill(""),
    ].slice(0, 10);
    setAdditionalDescs(updatedDescs);

    // Generate previews for NEW files only
    const newPreviewPromises = newSelectedFiles.map((file) => {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          const img = new Image();
          img.src = event.target.result;

          img.onload = () => {
            const canvas = document.createElement("canvas");
            const MAX_WIDTH = 600;
            const scale = MAX_WIDTH / img.width;
            canvas.width = MAX_WIDTH;
            canvas.height = img.height * scale;

            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

            resolve(canvas.toDataURL("image/jpeg", 0.7));
          };
        };
        reader.readAsDataURL(file);
      });
    });

    Promise.all(newPreviewPromises).then((newCompressedPreviews) => {
      setAdditionalPreviews((prev) => [...prev, ...newCompressedPreviews].slice(0, 10));
    });
  // 🔥 IMPORTANT for mobile
  e.target.value = null;
};

  const handleAdditionalDescChange = (index, value) => {
    const updated = [...additionalDescs];
    updated[index] = value;
    setAdditionalDescs(updated);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    if (!formData.title.trim() || !formData.price || !formData.category || !formData.storeid) {
      setError("Judul, harga, kategori, dan Store ID wajib diisi!");
      setLoading(false);
      return;
    }

    try {
      // 1. Create main product
      const productRes = await axios.post("https://api.kamulyaan.id/books", formData);
      const newProductId = productRes.data.id || productRes.data.insertId;

      if (!newProductId) {
        throw new Error("Gagal membuat produk - tidak ada ID yang dikembalikan");
      }

      console.log("✅ New product ID:", newProductId);

      // 2. Upload additional images (if any)
      if (additionalFiles.length > 0) {
        const formDataImages = new FormData();
        additionalFiles.forEach((file) => formDataImages.append("images", file));
        additionalDescs.forEach((desc) => formDataImages.append("desc", desc || ""));

        try {
          await axios.post(
            `https://api.kamulyaan.id/addimage/${newProductId}/images`,
            formDataImages,
            { headers: { "Content-Type": "multipart/form-data" } }
          );
        } catch (imgErr) {
          console.warn("Gagal upload gambar tambahan:", imgErr);
          alert("Produk berhasil ditambahkan, tetapi beberapa gambar tambahan gagal diupload.");
        }
      }

      alert("Produk berhasil ditambahkan!");
      navigate("/");
    } catch (err) {
      console.error("Add failed:", err);
      const errMsg = err.response?.data?.message || err.message || "Gagal menambahkan produk";
      setError(errMsg);
      alert("Gagal menambahkan produk: " + errMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="app" style={{ padding: "20px", maxWidth: "700px", margin: "0 auto" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
        <Link to="/" style={{ color: "#333", textDecoration: "none" }}>← Kembali</Link>
        <h1 style={{ margin: 0, fontSize: "1.8rem" }}>Tambah Item Baru</h1>
        <div style={{ width: "50px" }} />
      </div>

      <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        {/* Cover - Gallery & Camera */}
        <div style={{ textAlign: "center" }}>
          <label style={{ display: "block", marginBottom: "8px", fontWeight: "bold" }}>
            Cover Utama (opsional)
          </label>
          <img
            src={coverPreview}
            alt="Cover Preview"
            style={{
              width: "220px",
              height: "220px",
              objectFit: "cover",
              cursor: "pointer",
              border: "2px dashed #ccc",
              borderRadius: "12px",
              background: "#f8f9fa",
            }}
          />
          <p style={{ fontSize: "0.85rem", color: "#666", marginTop: "8px" }}>
            Pilih dari galeri atau ambil foto
          </p>

          <div style={{ display: "flex", justifyContent: "center", gap: "16px", marginTop: "12px" }}>
            <button
              type="button"
              onClick={() => coverGalleryRef.current.click()}
              style={{
                padding: "10px 20px",
                background: "#3498db",
                color: "white",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
              }}
            >
              Dari Galeri
            </button>
            <button
              type="button"
              onClick={() => coverCameraRef.current.click()}
              style={{
                padding: "10px 20px",
                background: "#27ae60",
                color: "white",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
              }}
            >
              Ambil Foto
            </button>
          </div>

          <input
            type="file"
            ref={coverGalleryRef}
            onChange={handleCoverGallery}
            style={{ display: "none" }}
            accept="image/*"
          />
          <input
            type="file"
            ref={coverCameraRef}
            onChange={handleCoverCamera}
            style={{ display: "none" }}
            accept="image/*"
            capture="environment"
          />
        </div>

        {/* Main fields */}
        <input
          type="text"
          name="title"
          value={formData.title}
          onChange={handleChange}
          placeholder="Judul produk *"
          required
          style={{ width: "100%", padding: "10px", borderRadius: "6px", border: "1px solid #ccc" }}
        />
        <textarea
          name="desc"
          value={formData.desc}
          onChange={handleChange}
          placeholder="Deskripsi lengkap produk"
          rows={5}
          style={{ width: "100%", padding: "10px", borderRadius: "6px", border: "1px solid #ccc" }}
        />
        <input
          type="number"
          name="price"
          value={formData.price}
          onChange={handleChange}
          placeholder="Harga *"
          required
          style={{ width: "100%", padding: "10px", borderRadius: "6px", border: "1px solid #ccc" }}
        />
        <input
          type="number"
          name="qty"
          value={formData.qty}
          onChange={handleChange}
          placeholder="Qty"
          style={{ width: "100%", padding: "10px", borderRadius: "6px", border: "1px solid #ccc" }}
        />
        <input
          type="text"
          name="web"
          value={formData.web}
          onChange={handleChange}
          placeholder="Link Web / Toko (opsional)"
          style={{ width: "100%", padding: "10px", borderRadius: "6px", border: "1px solid #ccc" }}
        />
        <select
          name="category"
          value={formData.category}
          onChange={handleChange}
          required
          style={{ width: "100%", padding: "10px", borderRadius: "6px", border: "1px solid #ccc" }}
        >
          <option value="">Pilih kategori</option>
          {categories.map((cat) => (
            <option key={cat.id} value={cat.category}>
              {cat.category}
            </option>
          ))}
        </select>
        <input
          type="text"
          name="storeid"
          value={formData.storeid}
          readOnly
          style={{
            width: "100%",
            padding: "10px",
            borderRadius: "6px",
            border: "1px solid #ccc",
            background: "#f0f0f0",
            color: "#555",
            cursor: "not-allowed",
          }}
        />
        <select
          name="active"
          value={formData.active}
          onChange={handleChange}
          style={{ width: "100%", padding: "10px", borderRadius: "6px", border: "1px solid #ccc" }}
        >
          <option value={1}>Aktif</option>
          <option value={0}>Nonaktif</option>
        </select>

        {/* Additional Images - FIXED to support multiple */}
        <div style={{ marginTop: "24px" }}>
          <h3>Gambar Tambahan (maks. 10)</h3>
          <input
            type="file"
            multiple
            accept="image/*"
            onChange={handleAdditionalFilesChange}
            style={{ margin: "12px 0", display: "block" }}
          />
          <p style={{ fontSize: "0.85rem", color: "#666" }}>
            Bisa pilih lebih dari satu gambar sekaligus
          </p>

          {additionalFiles.length > 0 && (
            <div style={{ display: "flex", flexDirection: "column", gap: "20px", marginTop: "16px" }}>
              {additionalFiles.map((file, idx) => (
                <div
                  key={idx}
                  style={{
                    border: "1px dashed #aaa",
                    borderRadius: "8px",
                    padding: "16px",
                    background: "#f9f9f9",
                  }}
                >
                  <img
                    src={additionalPreviews[idx] || URL.createObjectURL(file)}
                    alt={`preview ${idx + 1}`}
                    style={{
                      width: "160px",
                      height: "160px",
                      objectFit: "cover",
                      borderRadius: "6px",
                      marginBottom: "12px",
                      display: "block",
                    }}
                  />
                  <input
                    type="text"
                    placeholder="Deskripsi gambar ini (opsional, max 255 karakter)"
                    value={additionalDescs[idx] || ""}
                    onChange={(e) => handleAdditionalDescChange(idx, e.target.value)}
                    maxLength={255}
                    style={{ width: "100%", padding: "10px", borderRadius: "6px", border: "1px solid #ccc" }}
                  />
                </div>
              ))}
            </div>
          )}
          <p style={{ fontSize: "0.9rem", color: "#666", marginTop: "8px" }}>
            Gambar pertama akan menjadi tambahan utama jika cover tidak diisi
          </p>
        </div>

        <button
          type="submit"
          disabled={loading || !userData?.userid}
          style={{
            marginTop: "32px",
            padding: "14px 24px",
            background: loading || !userData?.userid ? "#aaa" : "#6bbe23",
            color: "white",
            border: "none",
            borderRadius: "8px",
            fontSize: "1.1rem",
            fontWeight: "bold",
            cursor: loading || !userData?.userid ? "not-allowed" : "pointer",
            width: "100%",
          }}
        >
          {loading ? "Menyimpan..." : "Tambah Item"}
        </button>

        {error && <p style={{ color: "red", textAlign: "center", marginTop: "12px" }}>{error}</p>}

        <Link
          to="/"
          style={{
            marginTop: "16px",
            textAlign: "center",
            display: "block",
            color: "#1976d2",
            textDecoration: "none",
          }}
        >
          ← Batal / Kembali ke Daftar
        </Link>
      </form>
    </div>
  );
};

export default Add;